import classNames from "classnames";
import { useTranslation } from "react-i18next";

import css from "../gantt.module.scss";

type ClashProps = {
  width: number;
  left: number;
  top: number;
  dayWidth: number;
  title?: string;
  className?: string;
};

export const Clash = ({ width, left, top, dayWidth, title, className }: ClashProps) => {
  const { t } = useTranslation();

  return (
    <div
      title={title || t("bookingClash")}
      className={classNames(css.clash, className)}
      style={{
        width,
        minWidth: dayWidth,
        transform: `translate(${left}px, ${top}px)`
      }}
    />
  );
};
